import { breakpoints } from './breakpoints';
import { getMediaQuery, useMatchMedia } from './use-match-media';

export const useIsCompactMode = () => {
  const isCompactMode = useMatchMedia({ maxWidth: breakpoints.small.max });

  return isCompactMode;
};

export const isCompactMode = () => {
  const query = getMediaQuery({ maxWidth: breakpoints.small.max });
  return window.matchMedia(query).matches;
};
